import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyByqZ7xuyiU6qy3gzRfPQZhhKNNKGhJamQ",
  authDomain: "instagram-clone-jv.firebaseapp.com",
  projectId: "instagram-clone-jv",
  storageBucket: "instagram-clone-jv.appspot.com",
  messagingSenderId: "926997532535",
  appId: "1:926997532535:web:9547e8f01531f6d76cdb72",
  measurementId: "G-S29KJ4NXJE",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;
